import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getUserData, updateWindowDimensions, getProgramData } from '../redux/app/actions'
import { useInternationalization } from '../hooks/Internationalization'
import BuildingPicker from '../components/BuildingPicker'
import Error from './Error'
import Guardian from './Guardian'
import Loading from '../components/Loading'
import Shield from './Shield'
import getAppInfo from '../lib/getAppInfo'

import { useCreateOccupancy } from '../hooks/useCreateOccupancy'
import { StorageService } from '../lib/StorageService'
import { Auth } from 'aws-amplify'

function AppSwitch({ authState }) {
    const isLoading = useSelector((state) => state.app.isLoading)
    const showBuildingPicker = useSelector((state) => state.app.showBuildingPicker)
    const showErrorPage = useSelector((state) => state.app.showErrorPage)
    const occupancies = useSelector((state) => state.app.occupancies)

    const createNewOccupancy = useSelector(state => state.auth.createNewOccupancy)

    const updateDimensions = () => {
        updateWindowDimensions(window.innerWidth, window.innerHeight)
    }

    useInternationalization()
    useCreateOccupancy()
    //useInit()

    useEffect(() => {
        if (authState === 'signedIn') {
            getUserData()
        }
        updateDimensions()
        // window.addEventListener('resize', updateDimensions)
        // return () => window.removeEventListener('resize', updateDimensions)
    }, [authState])

    // On page refresh, check if we have a saved building selection
    useEffect(() => {
        // Only run this if the building picker is going to be shown
        if (showBuildingPicker && occupancies && occupancies.length > 0) {
            const savedBuilding = StorageService.get('currentBuilding');
            const isPageRefresh = !window.performance ||
                window.performance.navigation.type === window.performance.navigation.TYPE_RELOAD;

            // If we have a saved building and this is a page refresh
            if (savedBuilding && isPageRefresh) {
                const matchedOccupancy = occupancies.find(o =>
                    (o.pk === savedBuilding.pk && o.sk === savedBuilding.sk) ||
                    (o.d2 === savedBuilding.d2)
                );

                if (matchedOccupancy) {
                    // Use the saved building data and skip the building picker
                    Auth.currentAuthenticatedUser().then((user) => {
                        getProgramData(matchedOccupancy, user);
                    });
                }
            }
        }
    }, [showBuildingPicker, occupancies]);

    if (authState !== 'signedIn') return null
    if (showErrorPage) return <Error />

    if (createNewOccupancy) return <Loading />

    // Check if we should show the building picker or if we should use saved selection
    const savedBuilding = StorageService.get('currentBuilding');
    const isPageRefresh = window.performance &&
        window.performance.navigation.type === window.performance.navigation.TYPE_RELOAD;

    // FIXED: Improve building picker display logic to prevent flashing
    // Only show picker when explicitly needed and not during state transitions
    const shouldShowPicker = showBuildingPicker &&
        !(savedBuilding && isPageRefresh) &&
        occupancies &&
        occupancies.length > 1;

    if (shouldShowPicker) return <BuildingPicker />

    if (isLoading) return <Loading />
    const app = getAppInfo()
    if (app.isShield) return <Shield />
    return <Guardian />
}

export default AppSwitch
